import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatOption } from 'projects/chat-common/src/lib/models/chat.option';
import { CommonModule } from "@angular/common";

@Component({
  selector: 'app-quick-actions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quick-actions.component.html',
  styleUrl: './quick-actions.component.scss'
})
export class QuickActionsComponent {

  @Input() actions: ChatOption[]
  @Output() quickMessage = new EventEmitter<ChatOption>();

  selectedAction: ChatOption = null;

  sendQuickMessage(option: ChatOption) {
    this.toggleSelection(option);
    this.quickMessage.emit(option);
    this.selectedAction = null;
  }

  toggleSelection(option: ChatOption) {
    this.selectedAction = this.selectedAction === option ? null : option;
  }
}
